import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ValidatorsService {
    
    static phoneRegex = /^(06|07)\d{8}$/;
    static internationalPhoneRegex = /^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/;
    static emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9.-]+$/;
    static emailTRegex = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}(?:\.[a-zA-Z]{2,3})?$/;
    static passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*\W).{8,}$/;
    static urlRegex = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/;

    constructor() {}
    
    static IsPassword(str: string): boolean{        
        let check: boolean = false;
        if(str && str != ''){
            check = ValidatorsService.passwordRegex.test(str);
        }
        return check;
    }
    
    static StringToRegex(str: string): RegExp{
        // Main regex
        let tempMain = str.match(/\/(.+)\/.*/);
        const main = (tempMain && tempMain.length > 1 ? tempMain[1] : '');

        // Regex options
        let tempOptions = str.match(/\/.+\/(.*)/);
        const options = (tempOptions && tempOptions.length > 1 ? tempOptions[1] : '');

        // Compiled regex
        return new RegExp(main, options)
    }
    
    static RemoveAccents(str: string) {
        if (str) {
            let str_norm = str.normalize('NFD').replace(/\p{Diacritic}/gu, '');
            return str_norm;
        }
        return '';
    }
    
    static CleanString(str: string){
        return ValidatorsService.RemoveAccents(str).trim().toLowerCase();
    }
}

